import { link as linkApi } from '@/api/link'
import store from '@/store'

let res = null

// 일정 PDF 링크발송 — 수신자측 비인증 인증게이트/일정조회 Vuex 모듈
export const link = {
    namespaced: true,
    state: {
        // 인증 성공 후 보유 (메모리만, persist 금지 — 보안)
        viewKey: null,
        meta: null,            // { type, seniorName, customerBranchIdx, homeReceiverIdx, yyyymm }
        // 일정 데이터
        seniorName: null,
        yyyymm: null,
        scheduleList: null,
        // 2026-04-30 일정표화면개편 — /recipient/service/plan/print 동일 구조 (단일 hridx 의 첫 항목)
        info: null,
        // 2026-05-05 본인부담금명세서 링크발송 — copay 데이터 (LinkCopayPrintCard 전용)
        copayData: null,
        // 인증 실패/잠금 상태 노출용
        attemptCount: null,
        remaining: null,
    },
    mutations: {
        LINK_VERIFY(state, payload) {
            state.viewKey = payload.viewKey
            state.meta = {
                type: payload.type,
                seniorName: payload.seniorName,
                customerBranchIdx: payload.customerBranchIdx,
                homeReceiverIdx: payload.homeReceiverIdx,
                yyyymm: payload.yyyymm,
            }
        },
        LINK_SCHEDULE(state, payload) {
            state.seniorName = payload.seniorName
            state.yyyymm = payload.yyyymm
            state.scheduleList = payload.scheduleList
            // 단일 수급자 컨텍스트 — 첫 항목을 info 로 노출 (CalendarCard 양식 props)
            state.info = (payload.scheduleList && payload.scheduleList[0]) || null
        },
        // 2026-05-05 본인부담금명세서 — copay 데이터 저장
        LINK_COPAY(state, payload) {
            state.seniorName = payload.seniorName
            state.yyyymm = payload.yyyymm
            state.copayData = payload
        },
        LINK_ATTEMPT(state, payload) {
            // 401(불일치)/410/423/404 응답 시 attempt/remaining 보존
            state.attemptCount = (payload && payload.attemptCount != null) ? payload.attemptCount : null
            state.remaining = (payload && payload.remaining != null) ? payload.remaining : null
        },
        CLEAR_LINK(state) {
            state.viewKey = null
            state.meta = null
            state.seniorName = null
            state.yyyymm = null
            state.scheduleList = null
            state.info = null
            state.copayData = null
            state.attemptCount = null
            state.remaining = null
        },
    },
    actions: {
        // @Description 일정 PDF 링크발송 — 인증 게이트 (생년월일 검증)
        async LINK_VERIFY({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await linkApi.post.verify(payload)

                console.log('LINK_VERIFY info', res)

                if (res.data.status === 200) {
                    commit('LINK_VERIFY', res.data.data)
                } else {
                    if (res.data.data) commit('LINK_ATTEMPT', res.data.data)
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('LINK_VERIFY error', error)
            }
        },
        // @Description 일정 PDF 링크발송 — 일정 조회 (매 호출 birthDate 재검증)
        async LINK_SCHEDULE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await linkApi.get.schedule(payload)

                console.log('LINK_SCHEDULE info', res)

                if (res.data.status === 200) {
                    commit('LINK_SCHEDULE', res.data.data)
                } else {
                    if (res.data.data) commit('LINK_ATTEMPT', res.data.data)
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('LINK_SCHEDULE error', error)
            }
        },
        // @Description 본인부담금명세서 링크발송 — copay 조회 (매 호출 birthDate 재검증)
        async LINK_COPAY({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await linkApi.get.copay(payload)

                console.log('LINK_COPAY info', res)

                if (res.data.status === 200) {
                    commit('LINK_COPAY', res.data.data)
                } else {
                    if (res.data.data) commit('LINK_ATTEMPT', res.data.data)
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('LINK_COPAY error', error)
            }
        },
    },
}



// WEBPACK FOOTER //
// ./src/store/modules/link.js